import { TransactionReviewStatus } from '../../enums/TransactionReviewStatus';
import { TransactionStatus } from '../../enums/TransactionStatus';
import { TransactionTypes } from '../../enums/TransactionTypes';
import { ColorModes } from '../../../Pricers/enums';

export const transactionTypeMapping = (transactionType: TransactionTypes) => {
  return transactionTypeNames[transactionType];
};

export const transactionTypeNames: Record<TransactionTypes, string> = {
  [TransactionTypes.live]: 'Live',
  [TransactionTypes.liveHypothetical]: 'Live - Hypothetical',
  [TransactionTypes.test]: 'Test',
  [TransactionTypes.valuation]: 'Valuation',
  [TransactionTypes.markedForDeletion]: 'Marked for Deletion',
  [TransactionTypes.internal]: 'Internal',
  [TransactionTypes.ifrsComponent]: 'IFRS Component',
};

export const transactionTypeColors: Record<TransactionTypes, ColorModes> = {
  [TransactionTypes.live]: ColorModes.success,
  [TransactionTypes.liveHypothetical]: ColorModes.blue,
  [TransactionTypes.test]: ColorModes.gray,
  [TransactionTypes.valuation]: ColorModes.gray,
  [TransactionTypes.markedForDeletion]: ColorModes.error,
  [TransactionTypes.internal]: ColorModes.gray,
  [TransactionTypes.ifrsComponent]: ColorModes.blue,
};

export const transactionTypeLabels: Record<TransactionTypes, string | undefined> = {
  [TransactionTypes.live]: 'Live',
  [TransactionTypes.liveHypothetical]: 'Hypo',
  [TransactionTypes.test]: 'Test',
  [TransactionTypes.valuation]: 'Draft',
  [TransactionTypes.markedForDeletion]: 'Pending Delete',
  [TransactionTypes.internal]: 'Draft',
  [TransactionTypes.ifrsComponent]: 'Component',
};

export const tradeStatusColors: Record<string, ColorModes> = {
  pending: ColorModes.warning,
  closed_out_not_matured: ColorModes.warning,
  deleted: ColorModes.error,
  deleted_pending: ColorModes.gray,
};

export const tradeStatusLabels: Record<string, string> = {
  pending: 'Pending',
  closed_out_not_matured: 'Closed',
  deleted: 'Deleted',
};

export const reviewStatusNames: Record<TransactionReviewStatus, string> = {
  [TransactionReviewStatus.pending]: 'Pending',
  [TransactionReviewStatus.approved]: 'Approved',
  [TransactionReviewStatus.amend]: 'Amend',
  [TransactionReviewStatus.rejected]: 'Rejected',
  [TransactionReviewStatus.problematic]: 'Problematic',
  [TransactionReviewStatus.reviewed]: 'Reviewed',
  [TransactionReviewStatus.pendingApproval]: 'Pending Approval',
};

export const reviewStatusMapping = (reviewStatus: TransactionReviewStatus) => {
  return reviewStatusNames[reviewStatus];
};

export const transactionStatusNames: Record<TransactionStatus, string> = {
  [TransactionStatus.closed]: 'Closed',
  [TransactionStatus.pmc]: 'PMC',
  [TransactionStatus.entity]: 'Entity',
  [TransactionStatus.open]: 'Open',
};

export const transactionStatusMapping = (
  transactionStatus: TransactionStatus,
) => {
  return transactionStatusNames[transactionStatus];
};
